import React from 'react';
import './FaleConosco.scss';
import avatar from './../../assets/avatares/inteiro_suporte.png';
import Title from '../../components/title/Title';
import { faArrowAltCircleRight, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useForm } from 'react-hook-form';
import { hasText, isEmail } from '../../utils/utils';
import { useDispatch } from 'react-redux';
import service from './../../services/site';
import { actions as actionsSite } from './../../redux/actions/site';

const FaleConosco = props => {
    const { register, handleSubmit, errors, reset} = useForm();
    const dispatch = useDispatch();

    const enviar = async data => {
        dispatch(actionsSite.setLoadingMsg("Enviando mensagem..."));
        const res = await service.sendContact(data);
        dispatch(actionsSite.setLoadingMsg(res.msg));
        setTimeout(() => {
            dispatch(actionsSite.setLoadingMsg(""));
            reset({});
        }, 3000);
    }

    return (
        <div className="background faleconosco">
            <Title title="Fale conosco" subtitle="Preenche o formulário e aguarde nossa resposta" />
            <div className="container">
                <div className="content">
                    <div className="layout">
                        <div className="avatar">
                            <img src={avatar} alt="leka" />
                        </div>
                        <div className="form">
                            <form className="formModule branco" onSubmit={handleSubmit(enviar)}>
                                <h3 className="tituloEtapa">Envie sua mensagem para a Leka</h3>
                                <div className={errors.nome ? "field error" : "field"}>
                                    <input name="nome" id="nome" onKeyUp={(e) => hasText(e)} type="text" ref={register({ required: true })} />
                                    <label htmlFor="nome">Nome Completo</label>
                                </div>
                                <div className="break"></div>
                                <div className={errors.email ? "field error" : "field"}>
                                    <input name="email" id="email" onKeyUp={(e) => hasText(e)} type="text" ref={register({ required: true, validate: { isEmail: value => isEmail(value) } })} />
                                    <label htmlFor="email">E-mail</label>
                                </div>
                                <div className={errors.ddd ? "field ddd error" : "field ddd"}>
                                    <input name="ddd" id="ddd" maxLength={2} onKeyUp={(e) => { hasText(e) }} type="text" ref={register({ required: true, validate: { isNumeric: value => !isNaN(value) } })} />
                                    <label htmlFor="ddd">DDD</label>
                                </div>
                                <div className={errors.celular ? "field error" : "field"}>
                                    <input name="celular" id="celular" maxLength={9} onKeyUp={(e) => { hasText(e) }} type="text" ref={register({ required: true, validate: { isNumeric: value => !isNaN(value) } })} />
                                    <label htmlFor="celular">Nº Celular</label>
                                </div>
                                <div className="break"></div>
                                <div className={errors.departamento ? "field error" : "field"}>
                                    <select name="departamento" id="departamento" className="hasText" ref={register({required:true})}>
                                        <option value="">Selecione um departamento</option>
                                        <option value="Comercial">Comercial</option>
                                        <option value="Suporte">Suporte</option>
                                        <option value="Cadastro">Cadastro</option>
                                    </select>
                                    <label htmlFor="departamento">Departamento</label>
                                </div>
                                <div className="break"></div>
                                <div className={errors.mensagem ? "field error" : "field"}>
                                    <textarea name="mensagem" id="mensagem" onKeyUp={(e) => { hasText(e) }} ref={register({ required: true })}></textarea>
                                    <label htmlFor="mensagem">Mensagem</label>
                                </div>
                                <div className="break"></div>
                                <div className="acoes">
                                    <button type="submit" className="salvar"><FontAwesomeIcon icon={faArrowAltCircleRight} /> Enviar</button>
                                    {/* <button type="button" className="cancelar" onClick={() => history.push('/painel/catalogos')}><FontAwesomeIcon icon={faBan} /> Cancelar</button> */}
                                </div>
                            </form>

                            {errors && Object.keys(errors).length > 0 &&
                                <div className="erros">

                                    {errors.nome?.type === 'required' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o campo Nome</div>}
                                    {errors.email?.type === 'required' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o campo E-mail</div>}
                                    {errors.email?.type === 'isEmail' && <div><FontAwesomeIcon icon={faTimes} /> Preencha um E-mail válido</div>}
                                    {errors.ddd?.type === 'required' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o campo DDD</div>}
                                    {errors.ddd?.type === 'isNumeric' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o campo DDD com apenas números</div>}
                                    {errors.celular?.type === 'required' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o campo Celular</div>}
                                    {errors.celular?.type === 'isNumeric' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o campo Celular com apenas números</div>}
                                    {errors.departamento?.type === 'required' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o campo Departamento</div>}
                                    {errors.mensagem?.type === 'required' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o campo Mensagem</div>}
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default FaleConosco;